import { SET_CITIZENSHIP_COUNTRY_CODE } from "../../constants";

import { createAction } from "../../utils";

const setCitizenshipCountry = createAction(SET_CITIZENSHIP_COUNTRY_CODE);

export const setCitizenshipCountryInSession =
  (countryCode) => (dispatch, getState) => {
    countryCode
      ? window.sessionStorage.setItem("customerCitizenshipCountry", countryCode)
      : window.sessionStorage.removeItem("customerCitizenshipCountry");

    dispatch(setCitizenshipCountry(countryCode));
  };
